import React from 'react'
import { Mutation } from "react-apollo";
import { DELETE_LAYOUT_TYPE,GET_LAYOUT_TYPE } from "../../../queries/layout_type";
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from '@material-ui/core';

function filteredData(selectedRows, layoutType, layoutTypes){
  selectedRows.data.forEach(d => {
    const id = layoutTypes[d.dataIndex].id;
      layoutType = layoutType.filter(e => e.id !== id)
    })
  return layoutType;
}

class DeleteLayoutType extends React.Component {
  render(){
    const { selectedRows, layoutTypes } = this.props;
    console.log(selectedRows);
    return (
      <Mutation
        mutation={DELETE_LAYOUT_TYPE}
        update={(store, { data: { deleteLayoutType } }) => {
          const { layoutType } = store.readQuery({ query: GET_LAYOUT_TYPE });
          store.writeQuery({
            query: GET_LAYOUT_TYPE,
            data: 
            { 
              layoutType: filteredData(selectedRows, layoutType, layoutTypes)
            }
          });
        }}
        >
        {deleteLayoutType => (
          <div>
            <IconButton aria-label="delete" onClick = {
              e => {
                e.preventDefault();
                selectedRows.data.forEach(d => {
                  const id = layoutTypes[d.dataIndex].id;
                  deleteLayoutType({ variables: {id: id }})  
                });
                
              }
            }>
              <DeleteIcon />
            </IconButton>
          </div>
        )}
      </Mutation>
    );
  }
};

export default DeleteLayoutType;